import React from 'react';
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {Container} from "react-bootstrap";

class ConfirmNewPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            user: null
        };
    }

    componentDidMount() {
        const { navigate } = this.props;

        if (this.props.email && this.props.token) {
            fetch(process.env.REACT_APP_API_URL + '/my-account/confirm-new-password/' + this.props.email + '/' + this.props.newPassword + '/' + this.props.token, {
                method: "GET",
                headers: {'Content-Type': 'application/json'}
            }).then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            user: result
                        });
                    },
                );
        }
    }

    render() {
        const { error, isLoaded } = this.state;

        var  content = null;

        if (error) {
            content = <h1>Token has expired or email is invalid</h1>
        } else if (!isLoaded) {
            content = <h1>Loading...</h1>
        }
        else {
            content = <div>
                <h1>Password has been updated!</h1>
                <br/>
                <NavLink className="btn btn-outline-primary"
                    to={"/login"}
                >
                    Login
                </NavLink>
            </div>;
        }

        return <div>
            <Container>
                {content}
            </Container>
        </div>
    }
}

export default withRouter(ConfirmNewPassword);
